module.exports = __webpack_public_path__ + "media/images/MegaphoneWithLegs-1927be15.svg";